import { Content, User } from '.';
import { Application } from './application.model';
import { FolderStat, FolderSummary } from './server-socket.model';
import { Connection } from './syncthing/';

// export type Device = IDevice | MinimalDeviceInfo;

export class Device {
  public _id: string;
  public name: string;
  public config: {
    distributionMode: number;
    maxRecvKbps: number;
    maxSendKbps: number;
    globalAnnounceServers: string;
    licenseId: string;
    syncthingId: string;
    scheduled: {
      active: boolean;
      start: number;
      end: number;
    };
  };
  public details: {
    address: string;
    message: string;
    website: string;
    location: any[]; // [<longitude>, <latitude>]
    disk: {
      total: number;
      used: number;
      free: number;
    };
    ip: string;
    c3version: string;
    scheduledPause: boolean;
    timezone: string;
  };
  public status: string;
  public createdAt: number;
  public updatedAt: number;
  public message: string;
  public users: User[];
  public contents: Content[];
  public applications: Application[];
  public connection: Connection;
  public completions: {};
  public completion: number;   // device total percentage
  public onGoingSyncs: number;
  public syncStatus: string;
  public total: Total;
  public systemInfo: SystemInfo;
  public summaries: FolderSummary[]
  public folderStat: FolderStat
}

export class DevicePaginationResponse {
  public page: number;
  public limit: number;
  public count: number;
  public devices: Device[]; //  | MinimalDeviceInfo[];
}

interface Total {
  progress: number;
  syncedSize: number;
  totalSize: number;
}
interface SystemInfo {
  updatedAt: Date;
  cpu: any; // CPU;
  mem?: { [key: string]: number };
  disk?: Disk[];
  bios?: any; // BIOS;
  battery?: any; // Battery;
  osInfo?: any; // OSInfo;
  wifiNetworks?: any[];
}
interface Disk {
  fs?: string;
  type?: string;
  size?: number;
  used?: number;
  use?: number;
  mount?: string;
}

export interface MinimalDeviceInfo {
  _id: string;
  name: string;
  config: { licenseId: string };
  freePerc?: number; // free disk space left (percentage)
}
export interface DevicesOverview {
  total: number;
  online: number;
  offline: number;
  configured: number;
  paused: number;
  synchronized: number;
  syncing: number;
  pending: number;
  disk?: {
    total?: number,
    used?: number,
  };
  almostFull?: MinimalDeviceInfo[];
}

export interface MassCheckCsv {
  repeated: string[];
  devices: Device[];
  validDevices: number;
  alreadyRegistered: Device[];
  analysed: number;
  total: number;
  loadingCsv?: boolean;
  percent?: number;
}
